<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Stream Mapping </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <!-- {{stream_list}} -->
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist" item-text="ay"
                        item-value="ay_id" label="Academic Year" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stream" return-object
                        :items="stream_list" item-text="stream_name" label="Stream" outlined />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" multiple dense rounded required v-model="sel_std_data"
                        item-value="std_id" :items="std_list" item-text="std" label="Standard" outlined />
                </v-col>
            </v-row>
            <v-row align="center" justify="center">
                <v-btn :disabled="stream == null || sel_std_data == null" dense outlined rounded class="button"
                    @click="save()">Apply</v-btn>
            </v-row>
            <span v-if="div_data != null">
                <v-row class="p-0 m-0">
                    <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                        <!-- export btn code -->

                        <!-- <v-btn color="success" dark class="exportbtn" outlined rounded>
                            <download-excel class="mar" :data="bookList1" :fields="table_fields" worksheet="StreamMapping" name="StreamMapping.xls"> <v-icon dark>mdi-file-excel</v-icon> Export </download-excel>
                        </v-btn> -->
                        <v-btn class="ma-2 no-display " rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'StreamMapping')" :loading="loader"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>


                        <!-- export btn code end-->
                    </v-col>
                    <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                        <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table"
                            single-line hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <v-data-table dense :headers="headers1" :items="bookList1" :search="search"
                        class="elevation-1 mytable" @current-items="getFiltered">
                        <template v-slot:item.status="{ item }">
                            <v-autocomplete v-if="item.status != 'Stream Not Mapped'" color="#0F2027" class="mt-1" dense
                                rounded required v-model="item.status" :items="stream_list" item-text="stream_name"
                                label="Stream" outlined />
                            <span v-else>{{ item.status }}</span>
                        </template>
                        <template v-slot:item.save="{ item }">
                            <v-btn v-if="item.status != 'Stream Not Mapped'" dense outlined rounded class="button"
                                @click="saveEdit(item)">Apply</v-btn>
                            <span v-else>{{ item.status }}</span>
                        </template>
                        <template v-slot:top class="pb-5">
                            <v-row justify="center" align="center">
                                <tr class="t-row">
                                    <div>
                                        <th>
                                            <v-row>
                                                <span v-for="header in headers1" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                            rounded dense outlined color="#0F2027" :label="header.text"
                                                            multiple clearable :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>
                    </v-data-table>
                </div>
            </span>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                search: "",
                snackbar_msg: "",
                color: "",
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                stream_list: null,
                stream: null,
                std_list: null,
                overlay: false,
                div_data: null,
                aylist: [],
                ay: null,
                overlay: false,
                filterArr: [],
                filters: {
                    std: [],
                    div_name: [],
                    ay: [],
                },
                headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "ay",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "div_name",
                    },
                    {
                        text: "Stream Mapping Status",
                        align: "center",
                        sortable: false,
                        value: "status",
                    },
                    {
                        text: "Edit",
                        align: "center",
                        sortable: false,
                        value: "save",
                    },
                ],
                table_fields: {
                    "Sr. No.": "srno",
                    "Academic Year": "ay",
                    Standard: "std",
                    Division: "div_name",
                    "Stream Mapping Status": "status",
                },
            };
        },
        computed: {
            bookList1() {
                return this.div_data.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Academic Year</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Stream Mapping Status</th>
     
     
    </tr>`;

  this.bookList1.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${item.ay}</td>
        <td>${item.std}</td>
        <td>${item.div_name}</td>
        <td>${item.status}</td>
       
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
            saveEdit(status) {
                const data = {
                    stream_id: status.status,
                    div_off_id: status.div_off_id,
                };
                axios
                    .post("/Admission/applyStreamEdit", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Stream Mapping Done Successfully");
                            this.onload();
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.div_data.map((d) => d[val]);
            },
            // getStream(){
            //     this.stream_list = null;
            //     this.stream = null;
            //     //  this.std_div_list = null;
            //     // this.sel_std_data = null;
            //     this.stream_list = this.sel_ay_data.stream_list;
            // },
            //  getStd() {
            //     this.std_div_list = null;
            //     this.sel_std_data = null;
            //     this.std_div_list = this.sel_ay_data.std_list;
            // },
            save() {
                const data = {
                    ay: this.ay,
                    standard: this.sel_std_data,
                    stream: this.stream.stream_id,
                };
                axios
                    .post("/Admission/applyStream", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Stream Mapping Done Successfully");
                            this.onload();
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.overlay = true
                //this.uid = localStorage.getItem("EPS-uid")
                axios
                    .post("/Admission/streamMappingHome")
                    .then((res) => {
                        this.stream_list = res.data.stream_list;
                        this.std_list = res.data.std_list;
                        this.sel_ay_data = res.data.curr_ay;
                        this.div_data = this.std_list[0].div_data;
                        this.aylist = res.data.aylist;
                         this.overlay = false
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                        this.overlay = false
                    })
                    .finally(() => {
                        //stop loader
                        this.overlay = false
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
   
</style>
